/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkAllReadResponse
 */
export interface MarkAllReadResponse {
    /**
     * Number of notifications marked as read
     * @type {number}
     * @memberof MarkAllReadResponse
     */
    updated: number;
}

/**
 * Check if a given object implements the MarkAllReadResponse interface.
 */
export function instanceOfMarkAllReadResponse(value: object): value is MarkAllReadResponse {
    if (!('updated' in value) || value['updated'] === undefined) return false;
    return true;
}

export function MarkAllReadResponseFromJSON(json: any): MarkAllReadResponse {
    return MarkAllReadResponseFromJSONTyped(json, false);
}

export function MarkAllReadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkAllReadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'updated': json['updated'],
    };
}

export function MarkAllReadResponseToJSON(json: any): MarkAllReadResponse {
    return MarkAllReadResponseToJSONTyped(json, false);
}

export function MarkAllReadResponseToJSONTyped(value?: MarkAllReadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updated': value['updated'],
    };
}

